import { AddToCartService } from "~/features/addToCart/AddToCartService";
import { ActionIconButton } from "~/common/components/Button/ActionIconButton";
import { usePurchasePlace, usePurchaseType } from "~/app/analytics/ga/recommendations/RecommendationContexts";
import {
  useHSATabularViewModalClose,
  useHSATabularViewModalOpen,
} from "~/features/selectionAssistant/housing/components/HousingTabularView/HousingProductTabularViewActionCell";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
// ATC btn
export const AddToCartAction = ({ productCode }: { productCode: string }) => {
  const purchase_place = usePurchasePlace();
  const purchase_type = usePurchaseType();
  const closeModal = useHSATabularViewModalClose();
  const openPreviousModal = useHSATabularViewModalOpen();

  const openAddToCart = () => {
    AddToCartService.openAddToCartWizard(
      {
        productCode: productCode,
        restrictionQuery: "",
        onCancelCallback: openPreviousModal,
      },
      {
        page: purchase_place,
        recommendationType: purchase_type,
        recommendationPlace: purchase_place,
      },
    );
    if (closeModal) {
      closeModal();
    }
  };

  return (
    <ActionIconButton
      data-test-id={"tabular-view-action-button-add-to-cart"}
      icon={<ShoppingCartIcon  />}
      disabled={window.SCHA.config.disableAllWS}
      inverted={true}
      onIconClick={openAddToCart}
      data-ta-spec={"housing_assistant_product_cart"}
    />
  );
};
